import router from '../_router';

export default {
    state: {
        currentDialog: '',
        dialogs: [],
        dialogProps: {},
        noEscape: 'false',
    },
    getters: {
        getCurrentDialog: state => state.currentDialog,
        getDialogProps: state => state.dialogProps,
        noEsc: state => state.noEscape,
    },
    mutations: {
        setDialogs(state, items) {
            state.dialogs = items;
        },
        clearDialogs(state) {
            state.dialogs = [];
        },
        setCurrentDialog(state, dialog) {
            state.currentDialog = state.dialogs.includes(dialog) ? dialog : '';
        },
        setDialogProps(state, props) {
            state.dialogProps = props;
        },
        clearDialogProps(state) {
            state.dialogProps = {};
        },
        setNoEsc(state, noEsc) {
            state.noEscape = String(noEsc);
        },
    },
    actions: {
        setDialogWithProps({ commit }, { dialog, props }) {
            commit('setDialogProps', props);
            commit('setCurrentDialog', dialog);
        },
        setNextDialog({ commit, rootGetters }) {
            if (!rootGetters['authentication/is_logged_in']) {
                commit('setCurrentDialog', 'LetsBegin');
                commit('setNoEsc', 'false');
            } else if (!rootGetters['authentication/seen_video']) {
                commit('setCurrentDialog', 'ShowVideo');
                commit('setNoEsc', 'true');
            } else if (rootGetters['authentication/question_answered']) {
                const studentData = rootGetters['authentication/student_data'];
                if (!rootGetters['authentication/answered_region']) {
                    router.push({ name: 'regions', params: { student_data: studentData } });
                } else if (!rootGetters['authentication/answered_area']) {
                    router.push({ name: 'areas', params: { student_data: studentData } });
                } else {
                    router.push({ name: 'explorer' });
                }
            } else {
                const studentData = rootGetters['authentication/student_data'];
                const hasRNE = rootGetters['authentication/has_rne'];
                commit('setCurrentDialog', (studentData && hasRNE) ? 'VerifyStudentData' : 'TellUsAboutYourself');
                commit('setNoEsc', 'true');
            }
        },
    },

    namespaced: true,
};
